var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTranslationOn = function SvgTranslationOn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3857 29.0372L18.9655 25.1H26.0345L27.6143 29.0372L27.6395 29.1H27.7071H30H30.148L30.0928 28.9627L23.7292 13.1445L23.6656 12.9664L23.6419 12.9H23.5714H21.4286H21.3581L21.3344 12.9664L21.2708 13.1445L14.9072 28.9627L14.852 29.1H15H17.2929H17.3605L17.3857 29.0372ZM25.1528 22.9H19.8472L22.5 16.2885L25.1528 22.9Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8994 7.1C13.8626 10.2001 12.1218 13.143 10.0001 15.5993C8.32648 13.6582 6.86829 11.3947 6.32759 8.97817L6.3101 8.9H6.23H4.202H4.08157L4.1037 9.01838C4.67858 12.0924 6.48652 14.8889 8.50299 17.2013C5.61285 20.0686 2.6087 21.9475 2.43369 22.057C2.43008 22.0593 2.42767 22.0608 2.42649 22.0615L2.3436 22.114L2.39452 22.1979L3.43252 23.9079L3.4845 23.9935L3.57004 23.9414C3.82681 23.7849 6.95619 21.8606 10.0219 18.823C11.1853 19.9784 12.3451 20.9798 13.3204 21.7428L13.3991 21.8044L13.4607 21.7256L14.6927 20.1516L14.7544 20.0728L14.6756 20.0112C13.7449 19.2839 12.63 18.3282 11.5171 17.2234C13.9692 14.4226 16.0636 10.9306 16.0995 7.1H20H20.1V7V5V4.9H20H12.1V3V2.9H12H10H9.9V3V4.9H2H1.9V5V7V7.1H2H13.8994Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTranslationOn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/TranslationOn.e3c42a07.svg";
export { ForwardRef as ReactComponent };